import axios from 'axios'

export default {
    search: function (request) {
        return axios.get('/api/vacancy/items', { params: request });
    },
    find: function (id) {
        return axios.get(`/api/vacancy/items/${id}`);
    },
    save: function (data) {
        return axios.post('/api/vacancy/items', data);
    },
    delete: function (id) {
        return axios.delete(`/api/vacancy/items/${id}`);
    }
}